/**
 * `TryAskingList` — the "TRY ASKING" empty-state suggestion list shared
 * by `/ask` and `/reports/new`. Rounded card with an internal divide-y
 * grid of `icon + title + hover ArrowUpRight` rows.
 */
import type { LucideIcon } from "lucide-react";
import { ArrowUpRightIcon } from "lucide-react";

export interface TryAskingSuggestion {
  icon: LucideIcon;
  title: string;
  prompt: string;
}

interface TryAskingListProps {
  suggestions: readonly TryAskingSuggestion[];
  onSelect: (prompt: string) => void;
}

export function TryAskingList({ suggestions, onSelect }: TryAskingListProps) {
  return (
    <section className="mt-7">
      <div className="flex items-center gap-2 px-1">
        <span className="text-xs font-medium uppercase tracking-wide text-muted">
          TRY ASKING
        </span>
        <span className="text-xs text-muted">{suggestions.length}</span>
      </div>
      <ul className="mt-2 overflow-hidden rounded-lg border border-line bg-paper divide-y divide-line">
        {suggestions.map((s) => (
          <li key={s.title}>
            <button
              type="button"
              onClick={() => onSelect(s.prompt)}
              className="group flex w-full items-center gap-3 px-4 py-3 text-left text-sm text-ink transition-colors hover:bg-bg"
            >
              <s.icon className="h-4 w-4 shrink-0 text-muted" aria-hidden />
              <span className="flex-1 truncate">{s.title}</span>
              <ArrowUpRightIcon
                className="h-4 w-4 shrink-0 text-muted opacity-0 transition-opacity group-hover:opacity-100"
                aria-hidden
              />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
